var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('dx-popup',{staticClass:"popup",attrs:{"visible":_vm.visible,"drag-enabled":false,"close-on-outside-click":true,"show-title":true,"title":_vm.title,"onHidden":_vm.hide,"fullScreen":_vm.fullScreen}},[_c('dx-toolbar-item',{attrs:{"widget":"dxButton","location":"before","options":{
        onClick: _vm.toggleFullScreen,
        stylingMode: 'text',
        type: 'success',
        icon: _vm.fullScreen ? 'fas fa-compress-arrows-alt' : 'fas fa-expand-arrows-alt'
    }}}),_c('img',{staticClass:"img-fluid",staticStyle:{"max-width":"100%","max-height":"100%"},attrs:{"src":_vm.url}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }